export const profilesSelector = ({ profiles }) => profiles;

export const profilesV2Selector = ({ profilesV2 }) => profilesV2;
